var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuRect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 230,
    viewBox: "0 0 201 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_20428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5C0.5 2.23858 2.73858 0 5.5 0H104.957C106.763 0 108.354 1.18581 108.869 2.91586C120.418 41.6538 175.297 41.5589 187.113 2.90169C187.639 1.18138 189.229 0 191.028 0H196C198.761 0 201 2.23858 201 5V225C201 227.761 198.761 230 196 230H5.49999C2.73857 230 0.5 227.761 0.5 225V5Z",
    fill: "url(#paint0_linear_1_20428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 5C1.25 2.65279 3.15279 0.75 5.5 0.75H104.957C106.431 0.75 107.73 1.71794 108.151 3.13012C119.915 42.594 175.802 42.4742 187.83 3.12093C188.26 1.7146 189.56 0.75 191.028 0.75H196C198.347 0.75 200.25 2.65279 200.25 5V225C200.25 227.347 198.347 229.25 196 229.25H5.49999C3.15279 229.25 1.25 227.347 1.25 225V5Z",
    stroke: "#989898",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_20428",
    x: -39.5,
    y: -40,
    width: 280.5,
    height: 310,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_20428"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_20428",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_20428",
    x1: 143.986,
    y1: 218,
    x2: -15.5442,
    y2: 101.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuRect);
export default __webpack_public_path__ + "static/media/menuRect.e57065cd05e949a6c68f57366ca0f858.svg";
export { ForwardRef as ReactComponent };